<template>
  <div v-loading="openLoading"
       class="third register-api-details">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon"
                @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务配置》{{currentName}}</span>
        </div>
        <div class="btn-right">
          <!-- <el-button @click="resetForm"
                     class="btn-two"
                     type="default">重置</el-button>
          <el-button @click="commit"
                     class="btn-two"
                     type="primary"
                     v-el-disabel-repeat-click>保存</el-button> -->
        </div>
      </div>
      <el-form :model="ruleForm"
               ref="ruleForm"
               :rules="rules"
               label-width="86px"
               @validate="validateValue"
               :show-message="false">
        <div class="formOne-forms">
          <div class="forms-one"
               style="margin-top: 57px">
            <div class="one-title"
                 style="display:flex;justify-content: space-between;">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
              <div class="btn-right">
                <el-button @click="resetForm"
                           class="btn-two"
                           type="default">重置</el-button>
                <el-button @click="commit"
                           class="btn-two"
                           type="primary"
                           v-el-disabel-repeat-click>保存</el-button>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="卡片顺序"
                            prop="orderNum">
                <el-input-number class="list-input elnumber"
                                 :min='1'
                                 :max='99'
                                 :step='1'
                                 step-strictly
                                 :controls='false'
                                 v-model="ruleForm.orderNum"
                                 placeholder="请输入正整数"></el-input-number>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">专题列表</span>
              </div>
            </div>
            <div class="one-list">
              <div class="third-one"
                   style="background-color: #fff; padding-top: 0;">
                <div class="phon-left">
                  <div class="third-do-btn">
                    <div class="do-btn-left">
                      <el-button icon="el-icon-plus"
                                 @click="openSpecial">新增</el-button>
                      <el-button icon="el-icon-delete"
                                 @click="delSpecial">刪除</el-button>
                    </div>
                  </div>
                </div>
                <fm-grid url="/api/blade-platform/themeArticle/list"
                         ref="themeArticleListTable"
                         :mapValue="{
                          data: 'dataList',
                          total: 'total'
                        }">
                  <template slot-scope="{rows,loading}">
                    <el-table class="third-tableThree"
                              :max-height="getMaxHeight(322)"
                              :data="rows"
                              border
                              stripe
                              v-loading="loading"
                              ref="otherTableBasic"
                              row-key="id"
                              @selection-change="handleSelectionChange">
                      <el-table-column type="selection"
                                       width="32px"></el-table-column>
                      <el-table-column prop="serviceName"
                                       width='200px'
                                       label="图片">
                        <template slot-scope="{ row }">
                          <el-image style="width: 175px;height:25px;marginTop:5px;"
                                    :src="row.articlePic"
                                    :preview-src-list="[row.articlePic]">
                          </el-image>

                        </template>
                      </el-table-column>
                      <el-table-column prop="name"
                                       label="名称"
                                       :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column prop="articleType"
                                       label="类型"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span>{{
                        row.articleType == "1" ? "自定义" :row.articleType == "2" ? "公众号": "链接"
                      }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="viewPermission"
                                       label="查看权限"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span>{{viewPermission(row.viewPermission)}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="sort"
                                       label="顺序"
                                       :show-overflow-tooltip="true"></el-table-column>
                      <el-table-column prop="status"
                                       label="状态"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span style="color:#17C295;"
                                v-if="row.status == 1">开启</span>
                          <span style="color:#FF4D4F;"
                                v-else>关闭</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="startTime"
                                       label="展示开始时间"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span>{{row.startTime | getTime}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="endTime"
                                       label="展示结束时间"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span>{{row.endTime | getTime}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="state"
                                       label="操作"
                                       :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                          <el-button type="text"
                                     size="small"
                                     @click="updateStatusMOdel(scope.row)">
                            {{ scope.row.status == 1 ? "关闭" : "开启" }}
                          </el-button>
                          <span class="tableThree-height-shu">
                            <span class="shu-item"></span>
                          </span>
                          <el-button type="text"
                                     size="small"
                                     style="marginLeft:0 !important;"
                                     @click="compile(scope.row)">
                            编辑
                          </el-button>
                          <span class="tableThree-height-shu">
                            <span class="shu-item"></span>
                          </span>
                          <el-button type="text"
                                     size="small"
                                     style="marginLeft:0 !important;"
                                     @click="deleteRowConfirm(scope.row)"
                                     :disabled="scope.row.editStatus === 'ALL'">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </fm-grid>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <notice-modal :noticeModalVisible="noticeModal"
                  @noticeModalClose="closeNotice"
                  @noticeModalAgree="agreeNotice"
                  :noticeTitle="noticeTitle"
                  :noticeSpec="noticeSpec"
                  :noticeType="noticeType"
                  :btnAgree="agreeContent"
                  :noticeContent="noitceContent">
    </notice-modal>
    <!-- <addOfficalAccounts :addModalVisible="addModalVisible"
                        @closeAddModal="closeAddModal"
                        :choosedList="currentTableData"
                        @addData="addData"></addOfficalAccounts> -->
  </div>
</template>

<script>
import { itemDetailPort, updatePort } from '@/api/appSetting/appServiceSetting'
import Sortable from 'sortablejs';
// import addOfficalAccounts from '../component/addOfficalAccounts'
import { uniqBy } from 'lodash';
import { setStore, getStore } from "@/utils/store";
import FmGrid from '../../../../components/grid/FmGrid.vue';
export default {
  name: "formSeven",
  props: ['rowId'],
  data () {
    return {
      currentName: '',
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      openLoading: false,
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: '确定', // 提示弹窗确认按钮内容
      noticeTitle: '提示', // 提示
      noitceContent: '确定删除吗？', // 提示信息
      noticeSpec: '删除后不可恢复，', // 标红提示
      noticeModal: false, // 提示弹窗
      //   &**************************************
      ruleForm: {
        orderNum: '',
      },
      rules: {
        orderNum: [
          { required: true, message: "请输入卡片顺序", trigger: "blur" },
        ],
        // showName: [{ required: false, message: "请输入展示名称", trigger: "blur" }],
        // homeRow: [{ required: true, message: "请选择公众号消息集合展示位置", trigger: "change" }],
        // openAll: [{ required: true, message: "请选择公众号消息集合", trigger: "change" }]
      },
      currentTableData: [],
      roleTree: [],
      selectionList: [],
      specialId: ''
    };
  },
  components: {
    FmGrid
    // addOfficalAccounts
  },
  created () {
    let a = getStore({
      name: "specialId",
      type: "session"
    })
    console.log(a);
    if (a) {
      this.specialId = a
    } else {
      setStore({
        name: "specialId",
        content: this.rowId,
        type: "session"
      })
    }
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.getRoleTree()
    this.itemDetail()

    // this.serviceBusDetail();
  },
  mounted () {
    this.themeArticleList()
  },
  watch: {
    rowId () {
      this.cpRowId = this.rowId
    },
  },
  filters: {
    getTime (time) {
      if (time) {
        let arr = time.split('')
        let a = arr.indexOf('T')
        arr.splice(a, 1, " ")
        return arr.join('')
      } else {
        return time
      }

    },
  },
  methods: {
    async getRoleTree () {
      const res2 = await this.$store.dispatch("getServiceRoleList");
      if (res2.data.status === 1000) {
        const { result } = res2.data;
        this.roleTree = result;
        console.log(this.roleTree);
      }
    },
    viewPermission (roles) {
      let childrenList = [];
      let roleArr = roles.split(',')// 整理角色列表 去除一级 只留二级数据
      this.roleTags = [];
      this.roleTree.forEach((element) => {
        element.children.forEach((ele) => {
          childrenList.push(ele);
        });
      });
      console.log(childrenList);
      console.log(roleArr);
      let arr = []
      for (let i = 0; i < roleArr.length; i++) {
        for (let j = 0; j < childrenList.length; j++) {
          if (roleArr[i] == childrenList[j].roleId) {
            arr.push(childrenList[j].roleName)
            break
          }
        }
      }
      return arr.join('，')
    },
    handleSelectionChange (selection) {
      this.selectionList = selection
    },
    themeArticleList () {
      console.log(1);
      this.$refs.themeArticleListTable.search({
        pageIndex: 1,
        pageSize: 40,
      });
    },
    openSpecial () {
      setStore({
        name: "specialDetail",
        content: '',
        type: "session"
      });
      this.$emit('changeComponent', 'specialDetail')
    },
    delSpecial () {
      if (this.selectionList.length == 0) {
        this.$message.error('请选择数据')
        return
      }
      let arr = []
      this.selectionList.forEach(item => {
        arr.push(item.id)
      })
      this.agreeNotice = () => {
        this.noticeModal = false
        this.deleteRow(arr.join(','))
      }
      this.noitceContent = '确定删除吗？', // 提示信息
        this.noticeSpec = '删除后不可恢复，', // 标红提示
        this.noticeModal = true
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit () {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            this.updateData()
          } else {
            return false;
          }
        });
      });
    },
    //表单重置
    resetForm () {
      this.$refs.ruleForm.clearValidate()
      this.$nextTick(() => {
        this.itemDetail()
      })
    },
    async updateData () {
      console.log('this.cpRowId', this.ruleForm.accessWay)
      const serviceList = [...this.currentTableData].map((el, index) => {
        return {
          openStatus: el.openStatus,
          orderNum: index,
          serviceId: el.serviceId
        }
      })
      const {
        data: {
          result, msg, status
        }
      } = await updatePort({
        ...this.ruleForm,
        serviceList
      })
      if (status === 1000) {
        this.$message.success('操作成功')
        this.changeComponent()
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    deleteRowConfirm (rowData, index) {
      this.agreeNotice = () => {
        this.noticeModal = false
        this.deleteRow(rowData.id)
      }
      this.noitceContent = '确定删除吗？', // 提示信息
        this.noticeSpec = '删除后不可恢复，', // 标红提示
        this.noticeModal = true
      // this.deleteRow(index)
    },
    async deleteRow (ids) {
      const { data: { result, status } } = await this.$store.dispatch('themeArticleRemove', {
        ids: ids
      })
      if (status === 1000) {
        this.$message.success('删除成功')
        this.themeArticleList()
      }
    },
    updateStatusMOdel (rowData) {
      console.log(rowData);
      this.agreeNotice = () => {
        this.openLoading = true
        this.noticeModal = false
        this.updateStatus(rowData)
      }
      if (rowData.status == '1') {
        this.noitceContent = '确定关闭吗？', // 提示信息
          this.noticeSpec = '关闭后对应角色下的用户不可查看该专题，', // 标红提示
          this.noticeModal = true
        return
      }
      this.noitceContent = '确定开启吗？', // 提示信息
        this.noticeSpec = '开启后对应角色下的用户可在专题有效时间范围内查看该专题，', // 标红提示
        this.noticeModal = true
    },
    updateStatus (rowData) {
      this.updateData2(rowData)
    },
    async updateData2 (rowData) {
      console.log(rowData);
      if (rowData.status == 1) {
        rowData.status = 0
      } else {
        rowData.status = 1
      }
      const {
        data: { result, msg, status },
      } = await this.$store.dispatch('themeArticleSaveOrUpdate', {
        ...rowData
      });
      if (status === 1000) {
        this.openLoading = false
        this.$message.success("操作成功");
        this.themeArticleList()
        console.log("结果", result);
        return;
      }
      this.openLoading = false
      return this.$message.error(msg);
    },
    async itemDetail () {
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await itemDetailPort({
        id: this.rowId ? this.rowId : this.specialId
      })
      if (status === 1000) {
        // ZBW 临时加上
        this.currentName = result.itemName
        this.ruleForm = result
        // this.currentTableData = [...result.serviceList]
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    // 关闭弹窗
    closeNotice () {
      this.noticeModal = false
    },
    // 改变index页面的component的值
    changeComponent () {
      this.$emit("changeComponent", 'homePage');
    },
    compile (row) {
      setStore({
        name: "specialDetail",
        content: row,
        type: "session"
      });
      this.$emit('changeComponent', 'specialDetail')
    },
  }
};
</script>
<style lang="scss">
.register-api-details {
  .elnumber {
    .el-input {
      input {
        text-align: left;
      }
    }
  }
  .tableThree-height-shu {
    display: inline-block;
    padding: 0 4px;
    position: relative;
    .shu-item {
      position: absolute;
      width: 1px;
      height: 12px;
      background-color: #d4d4d7;
      display: inline-block;
      top: -10px;
    }
  }
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
}
</style>
